export const MyOrganizationSubpageButtonLabels = {
  INFORMATIONS: 'COMPANY DETAILS',
  EMPLOYEES: 'EMPLOYEES',
  MY_WALLET: 'PAYMENT CARD',
  TRANSACTIONS: 'TRANSACTIONS',
  INVOICES: 'INVOICES',
};
